import keyMirror from 'keymirror';

export const listDetailsActionTypes = keyMirror({
	GET_LIST_DETAILS_REQUEST: null,
	GET_LIST_DETAILS_SUCCESS: null,
	GET_LIST_DETAILS_ERROR: null,

	GET_LIST_RESULTS_REQUEST: null,
	GET_LIST_RESULTS_SUCCESS: null,
	GET_LIST_RESULTS_ERROR: null,

	TOGGLE_ADD_LIST_MODAL: null,
	ADD_LIST_REQUEST: null,
	ADD_LIST_SUCCESS: null,
	ADD_LIST_ERROR: null,

	DUPLICATE_LIST_REQUEST: null,
	DUPLICATE_LIST_SUCCESS: null,
	DUPLICATE_LIST_ERROR: null,

	UPDATE_LIST_REQUEST: null,
	UPDATE_LIST_SUCCESS: null,
	UPDATE_LIST_ERROR: null,

	TOGGLE_CONFIRMATION_MODAL: null,

	DELETE_LIST_REQUEST: null,
	DELETE_LIST_SUCCESS: null,
	DELETE_LIST_ERROR: null,

	CLEAR_LIST_DETAILS: null,
	SET_LIST_STATUS: null,
	TOGGLE_COPY_LIST_MODAL: null,

	GET_LIST_SONGS_REQUEST: null,
	GET_LIST_SONGS_SUCCESS: null,
	GET_LIST_SONGS_ERROR: null,

	DELETE_SONG_REQUEST: null,
	DELETE_SONG_SUCCESS: null,
	DELETE_SONG_ERROR: null,
});

export const getListDetailsTab = (t) => [
	{ title: t('list_details.tabs.words'), value: '', index: 0 },
	{ title: t('list_details.tabs.results'), value: 'results', index: 1 },
	{ title: t('list_details.tabs.study_songs'), value: 'study-songs', index: 2 },
];

export const getPrintListsTabs = (t) => [
	{ title: t('list_details.print_list_tabs.table'), value: 'print-table', index: 0 },
	{ title: t('list_details.print_list_tabs.tickets'), value: 'print-cards', index: 1 },
];

export const getSectionTitles = (t) => [
	t('list_details.section_titles.wrong'),
	t('list_details.section_titles.usually_wrong'),
	t('list_details.section_titles.often_wrong'),
	t('list_details.section_titles.sometimes_wrong'),
	t('list_details.section_titles.usually_good'),
	t('list_details.section_titles.good'),
	t('list_details.section_titles.not_practiced'),
	t('list_details.section_titles.difficult'),
	t('list_details.section_titles.known'),
];

export const getPrintListsOrderOptions = (t) => [
	t('list_details.print_lists_order_options.original'),
	t('list_details.print_lists_order_options.alphabetically'),
];
